import React from "react";
import {TypeImageSkeleton} from "@/libs/contentful/types";
import {CustomNavItem} from "@/libs/contentful/fetch/content/navigation";
import NavLink from "@/components/Layout/Header/Navigation/NavLink";
import MegaMenu from "@/components/Layout/Header/Navigation/MegaMenu";
import NavFocusButton from "@/components/Layout/Header/Navigation/NavFocusButton";
import clsx from "clsx";
import {usePathname} from "next/navigation";
import {useTranslations} from "next-intl";

interface Props {
    navItem: CustomNavItem
}

const FocusButtonWrapper = ({children, condition, menuId, menuName}: { children?: React.ReactNode, condition: boolean, menuId: string, menuName: string }) => {
    return condition ? (
        <NavFocusButton menuId={menuId} menuName={menuName}>{children}</NavFocusButton>
    ) : (children)
}

export default function NavListElement({navItem}: Props) {
    const t = useTranslations('Defaults');
    return (
        <>
            {navItem.page.url?.values && <FocusButtonWrapper condition={navItem.subPages.length !== 0} menuId={navItem.id} menuName={navItem.title.values}>
                <NavLink
                    className={clsx(navItem.subPages.length === 0 ? 'p-mobile block md:p-[0]' : '', 'group/focus focus:outline-0 border-black text-link md:px-l lg:px-xl md:py-m')}
                    slug={navItem.page.url.values}
                    type={navItem.subPages.length !== 0 ? 'pageLink' : ''}
                    ariaLabel={t("navigatesTo") + ' ' + navItem.title.values + ' ' + t("page")}
                >
                    <span className={clsx(usePathname().includes(navItem.page.url.values) ? 'border-b-2 md:group-hover/hover:border-b-2' : 'md:group-hover/hover:border-b-[1px]', 'group-focus/focus:outline-offset-[5px] group-focus/focus:outline-2 group-focus/focus:outline-outline group-focus/focus:outline text-black')}>
                        {navItem.title.values}
                    </span>
                </NavLink>
            </FocusButtonWrapper>}
            {navItem.page.url?.values && navItem.subPages.length !== 0 && (
                <MegaMenu id={navItem.id}
                          url={navItem.page.url.values}
                          introHeadline={navItem.page.introHeadline?.values}
                          introText={navItem.page.introText?.values}
                          introImage={navItem.page.introImage as unknown as TypeImageSkeleton}
                          subPages={navItem.subPages}/>
            )}
        </>
    )
}